/** Shown from the info icon next to "Take to public" in the guide and guide pack editors. */
export function takeToPublicSteps(kind: "guide" | "guide pack"): string {
  return [
    `How to take this ${kind} to public:`,
    `1. Submit for approval.`,
    `2. An approver approves it. Approval publishes it in your organization.`,
    `3. Click Take to public. This sends a request to your approvers.`,
    `4. An approver opens Dashboard > Publishing approvals, filters by Promote and clicks Promote to public.`,
    `A public copy is then created under your organization's name. Your organization's copy stays as it is.`,
    ...(kind === "guide pack"
      ? [`Every guide in the pack is also made public. You'll see the list and confirm before anything is sent.`]
      : []),
    `Your org admin must allow public publishing in Org admin > Structure.`,
  ].join("\n");
}

export type PromoteStatus = "none" | "pending" | "promoted";

/** Reads the latest public-publish request outcome from the content's approval audit. */
export function promoteStatusFromAudit(audit?: { action?: string }[] | null): PromoteStatus {
  let cancelled = false;
  for (let i = (audit?.length || 0) - 1; i >= 0; i--) {
    const action = String(audit![i]?.action || "").toLowerCase();
    if (action === "promotetopublic") return "promoted";
    if (action === "requestpromote" && !cancelled) return "pending";
    if (action === "cancelpromote") cancelled = true;
  }
  return "none";
}
